import '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    subtitle3: React.CSSProperties;
    body3: React.CSSProperties;
    title1: React.CSSProperties;
    title2: React.CSSProperties;
    clampH1: React.CSSProperties;
    pagination: React.CSSProperties;
    buttoninput: React.CSSProperties;
    textarea: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    subtitle3?: React.CSSProperties;
    body3?: React.CSSProperties;
    title1?: React.CSSProperties;
    title2?: React.CSSProperties;
    clampH1?: React.CSSProperties;
    pagination?: React.CSSProperties;
    buttoninput?: React.CSSProperties;
    textarea?: React.CSSProperties;
  }

  interface CommonColors {
    white: string;
    black: string;
    text: {
      primary: string;
      secondary: string;
      teritary: string;
      inverse: string;
    };
    point: {
      point1: string;
      point2: string;
      point3: string;
      point4: string;
    };
    red: {
      50: string;
      100: string;
      200: string;
      600: string;
      900: string;
    };
    green: {
      50: string;
      100: string;
      200: string;
      600: string;
      900: string;
      opacity: {
        15: string;
      };
    };
    yellow: {
      200: string;
      900: string;
      opacity: {
        '200-30': string;
        '900-30': string;
        '900-60': string;
      };
    };
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    subtitle3: true;
    body3: true;
    title1: true;
    title2: true;
    clampH1: true;
    pagination: true;
    buttoninput: true;
    textarea: true;
  }
}
